import React from "react";
import { Box, Button, Stack, TextareaAutosize, Typography } from "@mui/material";

const canvasStyle = {
  width: "100%",
  height: "auto",
  display: "block",
  background: "#fff",
};

const textAreaStyle = {
  width: "100%",
  padding: "8px",
  fontSize: "0.95rem",
  fontFamily: "inherit",
  border: "1px solid #ccc",
  borderRadius: "4px",
  resize: "vertical",
  background: "#fafafa",
};

const TopazSignatureCanvasPanel = ({
  canvasRef,
  promptText,
  onReset,
  resetDisabled = false,
}) => (
  <Stack spacing={2}>
    <Typography>
      Capture the guest signature directly on the connected Topaz pad. The
      agreement text below is bound into the Topaz SigString for compliance,
      and the live signature is mirrored in this window.
    </Typography>
    <TextareaAutosize
      readOnly
      minRows={5}
      value={promptText}
      style={textAreaStyle}
    />
    <Box
      sx={{
        border: "1px solid #d0d5dd",
        borderRadius: "8px",
        overflow: "hidden",
        backgroundColor: "#ffffff",
        p: 1,
      }}
    >
      <canvas
        ref={canvasRef}
        width={640}
        height={180}
        style={canvasStyle}
      />
    </Box>
    <Typography variant="caption" color="text.secondary">
      Signature strokes will appear here while the guest signs on the Topaz
      pad. After capture completes, review the preview and click Save
      signature. Use Clear / Reset Topaz pad to restart if needed.
    </Typography>
    {onReset ? (
      <Stack direction="row" justifyContent="flex-end">
        <Button
          variant="outlined"
          color="inherit"
          onClick={onReset}
          disabled={resetDisabled}
          sx={{ textTransform: "none" }}
        >
          Clear / Reset Topaz pad
        </Button>
      </Stack>
    ) : null}
  </Stack>
);

export default TopazSignatureCanvasPanel;
